module.exports = __webpack_public_path__ + "img/ritmo.d36d0fbe.svg";